// Module
var code = "<div class=\"flex flex-container-row site-details\" ng-if=\"vm.currentTab === 'serialNumbers' && ('Security.Settings.SiteDetails.SerialNumbers' | webPermission: 'readOnly')\"> <div class=\"flex flex-container-row\" ng-include src=\"'configuration.html'\"/> </div>";
// Exports
module.exports = code;